// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-page-container-js": require("gatsby-module-loader?name=component---src-page-container-js!/opt/build/repo/src/PageContainer.js")
}

exports.json = {
  "2016-en.json": require("gatsby-module-loader?name=path---2016-en!/opt/build/repo/.cache/json/2016-en.json"),
  "2016-zh.json": require("gatsby-module-loader?name=path---2016-zh!/opt/build/repo/.cache/json/2016-zh.json"),
  "2016-ja.json": require("gatsby-module-loader?name=path---2016-ja!/opt/build/repo/.cache/json/2016-ja.json"),
  "2017-en.json": require("gatsby-module-loader?name=path---2017-en!/opt/build/repo/.cache/json/2017-en.json"),
  "2017-zh.json": require("gatsby-module-loader?name=path---2017-zh!/opt/build/repo/.cache/json/2017-zh.json"),
  "2017-ja.json": require("gatsby-module-loader?name=path---2017-ja!/opt/build/repo/.cache/json/2017-ja.json"),
  "2017-fr.json": require("gatsby-module-loader?name=path---2017-fr!/opt/build/repo/.cache/json/2017-fr.json"),
  "2017-es.json": require("gatsby-module-loader?name=path---2017-es!/opt/build/repo/.cache/json/2017-es.json"),
  "2017-id.json": require("gatsby-module-loader?name=path---2017-id!/opt/build/repo/.cache/json/2017-id.json"),
  "2018-en.json": require("gatsby-module-loader?name=path---2018-en!/opt/build/repo/.cache/json/2018-en.json"),
  "2018-zh.json": require("gatsby-module-loader?name=path---2018-zh!/opt/build/repo/.cache/json/2018-zh.json"),
  "2018-es.json": require("gatsby-module-loader?name=path---2018-es!/opt/build/repo/.cache/json/2018-es.json"),
  "2019-en.json": require("gatsby-module-loader?name=path---2019-en!/opt/build/repo/.cache/json/2019-en.json"),
  "2019-zh.json": require("gatsby-module-loader?name=path---2019-zh!/opt/build/repo/.cache/json/2019-zh.json"),
  "2019-es.json": require("gatsby-module-loader?name=path---2019-es!/opt/build/repo/.cache/json/2019-es.json"),
  "2019-ja.json": require("gatsby-module-loader?name=path---2019-ja!/opt/build/repo/.cache/json/2019-ja.json")
}

exports.layouts = {

}


// WEBPACK FOOTER //
// ./.cache/async-requires.js